import { FeedbackActionEnum } from '@daymade/api-contracts';
import GreenPageSection from 'components/GreenPageSection';
import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import { useUserStore } from 'hooks/stores/useUserStore';
import { useState } from 'react';
import { feedbackApiClient } from 'utils/apiClient';
import HttpStatusCode from 'utils/HttpStatusCode';

const SubmitPrizeSection = ({
  prizeCategory,
  descriptionText,
  suggestAPrizeId,
}: {
  prizeCategory: string;
  descriptionText: string;
  suggestAPrizeId: string;
}) => {
  const { currentUser } = useUserStore();
  const [prizeText, setPrizeText] = useState('');
  const [prizeSubmitted, setPrizeSubmitted] = useState(false);

  return (
    <GreenPageSection id={suggestAPrizeId}>
      {!prizeSubmitted ? (
        <>
          <Subheading className="normal-case">Suggest a prize..</Subheading>

          <p
            style={{
              maxWidth: '500px',
              fontWeight: 600,
              textAlign: 'center',
              fontSize: '1.1em',
            }}
          >
            {descriptionText}
          </p>
          <div
            style={{ height: '75px' }}
            className="bg-white w-full md:w-2/5 lg:w-1/3 rounded-full flex py-5 px-5 justify-between mt-5"
          >
            <input
              className="border-none hover:bg-gray-100 w-full mr-2 rounded-full px-3"
              placeholder="I'd love to win a..."
              autoComplete="off"
              onChange={(e) => {
                setPrizeText(e.target.value);
              }}
            />
            <RoundedButton
              style={{ minWidth: '100px' }}
              onClick={async () => {
                const userId = currentUser?.id;
                const result = await feedbackApiClient.public.sendFeedback({
                  body: {
                    action: FeedbackActionEnum.SUGGEST_PRIZE,
                    feedback: {
                      [FeedbackActionEnum.SUGGEST_PRIZE]: {
                        comment: prizeText,
                      },
                    },
                  },
                });
                if (result.status === HttpStatusCode.OK) {
                  setPrizeSubmitted(true);
                }
              }}
            >
              SUBMIT
            </RoundedButton>
          </div>
        </>
      ) : (
        <p
          style={{
            margin: '2em 1em',
            maxWidth: '300px',
            fontWeight: 'bold',
            fontSize: '1.1em',
          }}
        >
          Thanks for your suggestion! We'll be sure to review it soon.
        </p>
      )}

      <style jsx>{`
        textarea {
          margin-top: 20px;
          background-color: white;
          font-size: 17px;
          border: none;
          padding: 0.5em 1em;
          width: 100%;
          max-width: 500px;
          height: 90px;
          border-radius: 9px;
        }
      `}</style>
    </GreenPageSection>
  );
};

export default SubmitPrizeSection;
